<template>
  <div>
        <el-drawer
            class="teamlist-drawer"
            :visible.sync="cliquenumber"
            :show-close="false"
            ref="drawerRef"
            size="500px"
            :before-close="handleBeforeClose"
            direction="rtl">
            <div class="team-list">
                <div class="team-title">
                    <div class="w-80">
                        <div class="team-title-tiem">当前{{storeType==3?'供应商':'采购商'}}</div>
                        <div class="team-title-name">{{teamInfo.title}}</div>
                    </div>
                    <div class="dayDate-top-close" @click="$emit('closeDrawer')">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
                <template v-if="teamInfo.user_list&&teamInfo.user_list.length>0">
                    <div class=" team-bottom">
                        <el-button @click="changePosition(1,teamInfo.user_list[0])" icon="el-icon-view" type="primary" style="width: 100%;">查看企业信息</el-button>
                    </div>
                    <div class=" team-bottom">
                        <el-button @click="editStore(teamInfo.id)" icon="el-icon-edit-outline" type="success" style="width: 100%;" >编辑企业信息</el-button>
                    </div>
                    <div class="team-title-name text-left mt-4 textle">旗下销售</div>
                    <!--报价销售列表-->
                    <ul class="historyOfferSaleList">
                        <template v-for="(item,index) in teamInfo.user_list">
                            <li  :key="item.offer_uid" @click.stop="changePosition(1,item,teamInfo)" v-if="index>0">
                                <div class="offer_item">
                                    <img :src="'/images/avatar/avatar_'+item.sex+'.png'"   class="img" :key="item.offer_uid">
                                    <div class="offer_name">
                                        <div class="name">{{item.truename}}</div>
                                        <div class="phones" v-if="item.position_name">{{ item.position_name}}</div>
                                    </div>
                                    <div class="position">
                                       <div class="position_phone" @click.stop="handleCopy(item.mobile)">
                                            <el-tooltip class="item" effect="dark" :content="'手机号:'+item.mobile" placement="top">
                                                <i class="iconfont icon-shoujihao position_mobile"></i>
                                            </el-tooltip>
                                        </div>
                                        <div class="position_phone">
                                            <el-tooltip class="item" effect="dark" :content="!penid(item)?'已绑定':'未绑定'" placement="top">
                                                <i class="iconfont icon-weixin1 position_mobile  weixin" :class="{'check':!penid(item)}"></i>
                                            </el-tooltip>
                                        </div>
                                        <div class="position_phone" >
                                            <i class="iconfont icon-yanjing- position_mobile check"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="offer_btn">
                                    <p @click.stop="changePosition(3,item,teamInfo)" v-if="storeType==3"><i class="el-icon-edit-outline"></i>更改职位</p>
                                    <p @click.stop="changePosition(2,item,teamInfo)"><i class="el-icon-link"></i>解除关联</p>
                                </div>
                            </li>
                        </template>
                    </ul>
                    <!--暂无销售-->
                    <div v-if="teamInfo.user_list&&teamInfo.user_list.length<=1" class="no-data">
                        <img src="/images/order/icon_29.png">
                        <p>暂无销售~可添加新销售</p>
                    </div>
                    <div class=" team-bottom">
                        <el-button  style="width: 100%;" icon="el-icon-plus" @click="changePosition(4,'',teamInfo)" >添加新销售</el-button>
                    </div>
                    <div class=" team-bottom">
                        <el-button  style="width: 100%;" icon="el-icon-full-screen" @click="addPosition(teamInfo)" >邀请二维码</el-button>
                    </div>
                </template>
                <!--无企业账户-->
                <template v-else>
                    <div class=" team-bottom">
                        <span class="prompt">请先创建一个企业账号   </span>
                        <el-button @click="$emit('createAccount')" icon="el-icon-office-building" type="primary" style="width: 100%;">创建企业账号</el-button>
                    </div>
                </template>
            </div>
        </el-drawer>
        <!--邀请二维码弹框-->
        <el-dialog :title="teamInfo.title" :visible.sync="QRcodeShwo" width="600px" center >
            <div class="loadConfirm">
                <img :src="backgroundImage" alt="二维码" class="remove-margin" v-if="backgroundImage"/>
                <div class="formbuttton">
                复制二维码分享邀请人员、微信扫码并进行加入{{storeType == 2?'企业':'酒店销售'}}!
                </div>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    name: '',
    components: {},
    props: {
        teamInfo: {
            type: Object,
            default: () => {}
        },
        cliquenumber: {
            type: Boolean,
            default: false
        },
        storeType: {
            type: String,
            default: '0'
        }
    },
    data() {
        return {
            QRcodeShwo:false,
            backgroundImage:'',
        };
    },
    computed: {},
    watch: {
        
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions(['POST_GetInviteUnionQRCode']),
        //复制销售电话
            handleCopy(text){
                // 创建临时input
                const input = document.createElement('input')
                input.value = text
                document.body.appendChild(input)
                input.select()
                document.execCommand('copy')
                document.body.removeChild(input)
                this.$message.success('复制销售电话成功')
        },
        //销售操作信息
        changePosition(type,item,teamInfo){
            this.$emit('handleCommand',type,item,teamInfo)
        },
    //生成门店邀请二维码
      addPosition(item){
        this.backgroundImage='';
        this.POST_GetInviteUnionQRCode({
          data: {store_id:item.id,store_type:this.storeType},
          successFun: (res) => {
            this.QRcodeShwo = true;
            this.backgroundtext=item.title;
            this.backgroundImage = 'data:image/jpeg;base64,'+res.qr_code;
          },
        });
      },
    //编辑门店信息
      editStore(id) {
        if (!this.$GFUN.powerIsInArray([427,362,52,98])) { this._alert('您没有相关权限！',null,'error'); return; }
        let routeUrl = this.$router.resolve({name:'StoreBasicInfo',query:{type:this.storeType,store:id,none:1}});
        window.open(routeUrl.href, '_blank');
      },
      //关闭抽屉
      handleBeforeClose() {
        this.$emit('closeDrawer');
      },
      //判断是否有微信openid
    penid(data){
        return data.wechat_openid==''||data.uid==data.wechat_openid
      },
    }
};
</script>

<style lang="scss" scoped>
        .team-list{
            width: 100%;
            margin: 0 auto;
            padding: 0;
            height: 100%;
            position: relative;
            background-color: var(--smtc-color-back);
        }
        .team-title{
            text-align: left;
            display: flex;
            justify-content: space-between;
            width: 94%;
            padding: 12px 3%;
            background-color: #fff;
        }
        .team-title-tiem{
            color: #999;
        }
        .team-title-name{
            font-weight: bold;
            font-size: 18px;
            width: 100%;
            margin: 0 auto;
            margin-top: 10px;
        }
        .historyOfferSaleList{
            width: 94%;
            margin: 0 auto;
            li{
                width: 100%;
                border-radius: 8px;
                margin-top: 20px;
                padding: 12px 4%;
                border: 1px solid #eee;
                // box-shadow: 0px 0px 7px #eee;
                background-color: #fff;
                box-sizing: border-box;
                overflow: hidden;
                cursor: pointer;
                padding-bottom: 0;
            }
            .offer_item{
                display: flex;
            }
            img{
                width: 65px;
                height: 65px;
                border-radius: 50px;
                overflow: hidden;
            
            }
        }
        .offer_name{
            text-align: left;
            margin-left: 16px;
            height: 65px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .phone{
                margin-top: 6px;
                color: #999;
            }
        }
        .list-icon{
            margin-left: auto;
            display: flex;
            justify-content: center;
            flex-direction: column;
            color: #999;
        }
        .icon-shoujihao{
            margin-right: 2px;
            font-size: 13px;
        }
        .address{
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 40px;
        }
        .address-content{
            display: flex;
            align-items: center;
        }
        .address-content p{
            width: 80%;
            overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;
            font-size: 12px;
            color: #999;
        }
        @media (max-width:1801px){
            .findhotel-list li{
                width: 46%;
            }
        }
        .phones{
            font-weight: normal;
            margin-top: 12px;
            background-color: #fdf0e4;
            font-size: 11px;
            margin-top: 6px;
            padding: 4px 6px;
            border-radius: 4px;
            color: #ab753e;
        }
        .position_phone{
            margin-left: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-right: 10px;
        }
        .position_mobile{
            background-color: #edf5fe;
            width: 40px;
            height: 40px;
            border-radius: 50px;
            text-align: center;
            line-height: 40px;
            color:var(--smtc-color-primary);
            font-size: 16px;

        }
        .position{
            margin-left: auto;
            display: flex;
        }
        .dayDate-top-close{
            background-color: #f9fafb ;
            width: 30px;
            text-align: center;
            height: 30px;
            line-height: 30px;
            border-radius: 50px;
            color: #666;
            font-size: 16px;
            cursor: pointer;
        }
        .offer_btn{
            display: flex;
            justify-content: center;
            border-top: 1px solid #eee;
            padding-top:6px;
            margin: 6px 0;
            color: #666;
            p{
                width: 50%;
                line-height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                i{
                    margin-right: 6px;
                }
            }
            p:nth-child(2){
                border-left: 1px solid #eee;
            }
        }
        .loadConfirm{
            text-align: center;
        }
        .loadConfirm img{
            width: 60%;
            margin-bottom: 20px;
        }
        .no-data{
            text-align: center;
            width: 94%;
            margin: 10px auto;
            padding: 20px 0;
            // background-color: #fff;
            border-radius: 4px;
            img{
                width: 180px;
            }
            p{
                font-size: 14px;
                color: #999;
            }
        }
        .team-bottom{
            width: 94%;
            margin: 16px auto;
        }
        .textle{
            width: 94%;
            margin: 0 auto;
        }
        .prompt{
            font-size: 12px;
            color: #999;
            margin-bottom: 16px;
            display: block;
        }
        .weixin{
            background-color: #f5f5f5;
            color: #999;
        }
        .check{
            background-color: #ebfbf0;
            color: #12bb47;
        }
</style>
<style>
    .teamlist-drawer .el-drawer__header{
        padding: 0 !important;
        margin-bottom: 0;
    }
</style>